import { Component, Input, Output, EventEmitter, HostListener, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserDetailResponse } from '@edtech-ui/core/models/Classroom/user-detail';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CompanyOnboardingService } from '../../../services/company-onboarding.service';
import { environment } from 'environments/environment';

@Component({
	selector: 'app-recruiter-header',
	standalone: true,
	imports: [CommonModule, FormsModule, MatTooltipModule],
	templateUrl: './recruiter-header.component.html',
	styleUrls: ['./recruiter-header.component.scss']
})
export class RecruiterHeaderComponent implements OnInit, OnDestroy {

	@Input() isSidebarCollapsed = false;

	@Output() toggleMobileMenu = new EventEmitter<void>();
	@Output() globalSearch = new EventEmitter<string>();
	@Output() logout = new EventEmitter<void>();
	@Output() navigateToTab = new EventEmitter<string>();
	subscription = new Subscription();
	userDetail: UserDetailResponse['Data'] | null = null;
	companyProfile: any = null;
	userId = '';

	searchVal = '';
	showProfileMenu = false;

	getLogoUrl(url: string | null | undefined): string {
		if (!url) return '';
		if (url.startsWith('http') || url.startsWith('data:')) {
			return url;
		}
		const baseUrl = environment.companyApiUrl;
		return url.startsWith('/') ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
	}

	constructor(
		private eRef: ElementRef,
		private _toastr: ToastrService,
		private _authService: AuthServiceService,
		private companyService: CompanyOnboardingService
	) { }


	ngOnInit(): void {
		const storedId = localStorage.getItem('user_id');
		if (storedId) {
			this.userId = storedId;
			this.getUserInfo(this.userId);
		}

		this.subscription.add(
			this.companyService.companyProfile$.subscribe(profile => {
				this.companyProfile = profile;
			})
		);

		this.subscription.add(
			this.companyService.getCompanyProfile().subscribe({
				error: (err) => {
					console.error('Error fetching company profile:', err);
				}
			})
		);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: Event): void {
		if (this.showProfileMenu && !this.eRef.nativeElement.contains(event.target)) {
			this.closeProfileMenu();
		}
	}

	onSearchChange(): void {
		this.globalSearch.emit(this.searchVal);
	}

	onToggleMobileMenu(): void {
		this.toggleMobileMenu.emit();
	}

	toggleProfileMenu(event: Event): void {
		event.stopPropagation();
		this.showProfileMenu = !this.showProfileMenu;
	}

	closeProfileMenu(): void {
		this.showProfileMenu = false;
	}

	onLogout(): void {
		this.logout.emit();
	}

	selectTab(tab: string): void {
		this.navigateToTab.emit(tab);
		this.showProfileMenu = false;
	}

	getUserInfo(id: string) {
		this.subscription.add(
			this._authService.getUserDetails(id).subscribe({
				next: (response: UserDetailResponse) => {
					if (response.Success) {
						this.userDetail = response.Data;
					}
				},
				error: () => this._toastr.error('Something went wrong while fecthing the user Details')
			})
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}
